import React from "react";

import CategorySecondaryOptionContainer from "./CategorySecondaryOptionContainer";

function CategorySecondaryOption(props) {
  return (
    <div className="p-3">
      <CategorySecondaryOptionContainer />
    </div>
  );
}

export default CategorySecondaryOption;
